// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"17":"d0142f49","37":"564b2a38","67":"e00d8e67","73":"251d6555","176":"656b63a2","232":"0c2eb542","335":"7016117b","410":"7938872c","509":"b45678c2","704":"a83c119c"}[chunkId] + ".js";
};